import { render, staticRenderFns } from "./QuickAddClient.vue?vue&type=template&id=5ea625b5&"
import script from "./QuickAddClient.vue?vue&type=script&lang=ts&"
export * from "./QuickAddClient.vue?vue&type=script&lang=ts&"
import style0 from "./QuickAddClient.vue?vue&type=style&index=0&id=5ea625b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports